import Apollo from '@/graphql/vue-apollo'

import { VerifyToken, CreateUserAccount, SendPasswordReset, ResetPassword } from './user.graphql'
import { LocalUserIsConnected, LocalUserToken, UpdateLocalUser } from '@/graphql/local/user.graphql'

export default {
  isConnected() {
    let result = Apollo.instance.defaultClient.readQuery({
      query: LocalUserIsConnected
    })

    return result.user.isConnected
  },
  getAccessToken() {
    let result = Apollo.instance.defaultClient.readQuery({
      query: LocalUserToken
    })

    return result.user.accessToken
  },
  getRefreshToken() {
    let result = Apollo.instance.defaultClient.readQuery({
      query: LocalUserToken
    })

    return result.user.refreshToken
  },
  async setLocalUser(isConnected, type, accessToken, refreshToken) {
    const user = {
      isConnected,
      type,
      accessToken,
      refreshToken
    }

    await Apollo.instance.defaultClient.mutate({
      mutation: UpdateLocalUser,
      variables: {
        user
      }
    })
  },

  createUserAccount: async function(email, firstName, lastName, password) {
    await Apollo.instance.defaultClient.mutate({
      mutation: CreateUserAccount,
      variables: {
        input: {
          email,
          firstName,
          lastName,
          password
        }
      }
    })
  },
  verifyToken: async function(email, token, type) {
    let result = await Apollo.instance.defaultClient.query({
      query: VerifyToken,
      variables: {
        email,
        token,
        type
      }
    })
    return result.data.verifyToken
  },
  sendPasswordReset: async function(email) {
    let input = { email }

    await Apollo.instance.defaultClient.mutate({
      mutation: SendPasswordReset,
      variables: {
        input
      }
    })
  },
  resetPassword: async function(emailAddress, newPassword, token) {
    let input = { emailAddress, newPassword, token }

    await Apollo.instance.defaultClient.mutate({
      mutation: ResetPassword,
      variables: {
        input
      }
    })
  }
}
